import { Region } from '@components/common/constants';
import { BACKEND_BASE_URL } from '@config';

export const getBackendUrl = (region: Region): string => BACKEND_BASE_URL[region];
